import { css, keyframes } from '@emotion/react'
import { Theme } from '@mui/material'

const fadeIn = keyframes`
  from {
    opacity: 0.5;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const thumbnailListItem = (theme: Theme) => css`
  background-color: #fff;
  border-radius: 8px 8px 60px 0px;
  overflow: hidden;
  width: 415px;
  height: 560px;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.15));
  transition: box-shadow 0.2s ease-in-out;
  animation: ${fadeIn} 0.2s ease-in-out;

  display: flex;
  flex-direction: column;

  .thumbnail {
    height: 226px;
    min-height: 226px;
    width: 100%;
    position: relative;

    :hover {
      cursor: pointer;
    }

    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-color: ${theme.palette.white.dark};
    }
  }

  .label {
    padding: 36px;

    .format {
      font-size: 12px;
      line-height: 1.2;
      font-weight: 800;
      color: ${theme.palette.uintel.main};
    }

    .title {
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.2;
      color: ${theme.palette.black.main};
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: normal;
    }

    .description {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      margin-top: 8px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    .chapterCount {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      margin-top: 20px;
    }

    .button {
      position: absolute;
      bottom: 32px;
      right: 36px;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      color: ${theme.palette.blue.light};
      line-height: 1.55;
    }

    .shareButton {
      position: absolute;
      bottom: 32px;
      right: 110px;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      color: ${theme.palette.blue.light};
      line-height: 1.55;
      margin-right: 20px;
    }
  }

  &:hover {
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  }
`

export const copyButton = css`
  margin-left: 10px;
  background: #0074d3;
  border-radius: 0 4px 4px 0;
`

export const textfieldWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
`

export const shareDialog = css`
  min-width: 600px;
  min-height: 457px;
`

export const publishIndicatorBadge = (visibility: string) => css`
  position: absolute;
  bottom: 183px;
  left: 330px;
  display: flex;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-transform: none;
  color: ${visibility == 'Public' ? '#000' : '#fff'};
  background-color: ${visibility == 'Public' ? '#61C9DC' : '#0B2948'};
`
